import { Component } from "react";
import { styled } from "@sourceful/shared-components";
import toRem from "@styles/postprocess/conversion/to-rem";
import Flickity from "react-flickity-component";
import ImagePreviewRadio from "@components/imagePreviewRadio";
import { getSanityImgUrl } from "@lib/sanity";
import { BasicImage } from "@lib/utils/sanityImageToBasicImage";
import { FlickityCarouselEvents } from "./GalleryWrapper";

const ImagePreviewCarousel = styled("div", {
  display: "flex",
  padding: toRem(5),
  width: "clamp(300px, 100%, 500px)",
  overflow: "auto",
  ".image-preview-radio": {
    padding: toRem(5),
  },
  ".control-carousel": {
    paddingLeft: toRem(40),
    paddingRight: toRem(40),
    ".flickity-button": {
      color: "$palette1_colour1",
      background: "none",
    },
    ".flickity-button-icon": {
      transform: "scale(0.7)",
    },
    ".flickity-prev-next-button.previous": {
      width: "48px",
      height: "48px",
      left: "-5px",
    },
    ".flickity-prev-next-button.next": {
      width: "48px",
      height: "48px",
      right: "-5px",
    },
    width: "100%",
  },
  variants: {
    isHidden: {
      true: {
        opacity: 0,
      },
    },
  },
});

interface ControlCarouselProps {
  images: BasicImage[];
  isMainImageReady: boolean;
  registerControlCarousel: (c: Flickity) => void;
  selectedIndex: number | undefined;
  handleSelect: (index: number) => void;
  flicketyEvents?: FlickityCarouselEvents;
}

class ControlCarousel extends Component<ControlCarouselProps> {
  render() {
    const {
      isMainImageReady,
      registerControlCarousel,
      images,
      selectedIndex,
      handleSelect,
      flicketyEvents,
    } = this.props;

    return (
      <ImagePreviewCarousel
        className="disable-scrollbar image-preview-carousel"
        isHidden={!isMainImageReady}
      >
        <Flickity
          flickityRef={registerControlCarousel}
          className={"control-carousel"}
          options={{
            prevNextButtons: true,
            initialIndex: 0,
            setGallerySize: true,
            wrapAround: false,
            cellAlign: "center",
            contain: true,
            pageDots: false,
            resize: true,
            // @ts-ignore
            on: {
              ready: () => {
                if (flicketyEvents?.onReady) {
                  flicketyEvents.onReady();
                }
              },
              change: (index: number) => {
                if (flicketyEvents?.onChange) {
                  flicketyEvents.onChange(index);
                }
              },
            },
          }}
        >
          {images.map((image, index) => {
            const _ref = image.assetRef;

            return (
              <ImagePreviewRadio
                key={_ref}
                isChecked={(selectedIndex ?? 0) === index} // defaults to 0 if no selected index is set
                value={_ref}
                imageUrl={getSanityImgUrl(_ref, base => base.height(60).width(60))}
                inputId={_ref}
                handleChange={() => {
                  handleSelect(index);
                }}
                tooltipId={`image-preview-radio-${image.assetRef}`}
              />
            );
          })}
        </Flickity>
      </ImagePreviewCarousel>
    );
  }
}

export default ControlCarousel;
